import React from "react";
import { T } from "../../../app/tokens.js";
import { convertAmount } from "../../../utils/fxConvert.js";

export function hasRecoveryBasis(lease) {
  return !!(lease?.recoveryCoverage?.recordCount || lease?.recoveryCoverage?.partial);
}

export function netRentDisplay(lease, currency = "USD", rates = null) {
  const converted = convertAmount(lease?.annualRentUsd, "USD", currency, rates);
  return { amount: converted ?? lease?.annualRentUsd ?? null, currency: converted == null ? "USD" : currency };
}

export function formatAnnualUsd(amount) {
  return amount == null ? "unavailable" : new Intl.NumberFormat("en-US", {
    style: "currency", currency: "USD", maximumFractionDigits: 0,
  }).format(amount);
}

export function AnnualRentBreakdown({ lease }) {
  if (!hasRecoveryBasis(lease)) return null;
  const c = lease.recoveryCoverage;
  return <div data-testid="annual-rent-breakdown" style={{ fontSize: T.fsXxs, color: T.mid, whiteSpace: "normal" }}>
    <div>Gross liability {formatAnnualUsd(lease.grossAnnualRentUsd)}</div>
    <div>Sublease income {c.knownCount === 0 ? "not recorded" : formatAnnualUsd(-lease.subleaseRecoveryUsd)}</div>
    {c.partial && <div>Partial coverage · {c.missingFxCount ? "recovery FX unavailable" : "income not fully recorded"}</div>}
  </div>;
}
